import mutations from './eesztLog.mutations'
import actions from './eesztLog.actions'
import getters from './eesztLog.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
